export default "__VITE_ASSET__CKiFqB7c__"